$(document).ready(function() {    
    if($('.filter-group').hasClass('filter-group--swatch')){
        $('.filter-group__heading').removeClass('toggle-target-toggler--is-hidden');
        $('.filter-group__items').removeClass('toggle-target--hidden'); 

    }  
  var windowWidth = $(window).width();
  if( windowWidth < 767 ){
     $('.section-footer__title').parent().siblings().children('.section-footer__menu-block__menu').slideUp('300');
      $('.section-footer__title').click(function () {
      $(this).parent().toggleClass('active');
      $(this).siblings().slideToggle('300');
      });  
  }
});

